import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CellcomFiberBlockData from 'app/Models/Content/CellcomFiberBlockData';
import React from 'react';
import {getImageProps} from 'app/utilities/ImageProps';
import {Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import TagName from 'app/Components/Shared/TagName';

const CellcomFiberBlock = ({data, context}: ComponentProps<CellcomFiberBlockData>) => {
  const {fadeClass, ref} = useFadeIn();
  return (
    <Container>
      <a href={data.buttonLink.value} ref={ref} className={`CellcomFiberBlock ${fadeClass}`}>
        <div className='CellcomFiberBlock__title-subtitle-button'>
          <TagName className='CellcomFiberBlock__title-subtitle-button__title' tagName={data.titleHeadlineTag?.value} isTitle>
            {data.title?.value}
          </TagName>
          <TagName tagName={data.subtitleHeadlineTag?.value} className='CellcomFiberBlock__title-subtitle-button__subtitle'>
            {data.subtitle?.value}
          </TagName>
          <div className='CellcomFiberBlock__title-subtitle-button__button'>{data.buttonLinkTitle?.value}</div>
        </div>

        <Image {...getImageProps(isMobile ? data.mobileImage : data.image, context)} />
      </a>
    </Container>
  );
};

export default CellcomFiberBlock;
